<!-- src/components/ui/SkeletonBlock.vue — skeleton loaders (placeholder-glow), not spinners -->
<script>
export default {
  name: "SkeletonBlock",
  props: {
    // variant: 'table' | 'chart' | 'tiles' | 'lines'
    variant: { type: String, default: "lines" },
    rows: { type: Number, default: 5 },
    cols: { type: Number, default: 4 },
    height: { type: String, default: "300px" },
    tiles: { type: Number, default: 4 },
  },
};
</script>

<template>
  <div class="placeholder-glow">
    <!-- table skeleton -->
    <div v-if="variant === 'table'">
      <div class="d-flex gap-3 mb-3">
        <span v-for="c in cols" :key="'h'+c" class="placeholder col rounded" style="height:14px"></span>
      </div>
      <div v-for="r in rows" :key="'r'+r" class="d-flex gap-3 mb-2">
        <span v-for="c in cols" :key="r+'-'+c" class="placeholder col rounded" style="height:20px"></span>
      </div>
    </div>

    <!-- chart skeleton -->
    <div v-else-if="variant === 'chart'" class="placeholder rounded w-100" :style="`height:${height}`"></div>

    <!-- KPI tiles skeleton -->
    <div v-else-if="variant === 'tiles'" class="row">
      <div v-for="t in tiles" :key="'t'+t" class="col-xl-3 col-md-6 mb-3">
        <div class="card"><div class="card-body">
          <span class="placeholder col-6 rounded d-block mb-3" style="height:12px"></span>
          <span class="placeholder col-4 rounded d-block" style="height:26px"></span>
        </div></div>
      </div>
    </div>

    <!-- generic lines -->
    <div v-else>
      <span v-for="r in rows" :key="'l'+r" class="placeholder col-12 rounded d-block mb-2" style="height:16px"></span>
    </div>
  </div>
</template>
